import firebase from "firebase";

// The Firebase Admin SDK to access Firestore.

// nodiant@fawtrust.cymru

const LIVE_DATABASE =
    "https://nodiant-e20a8-default-rtdb.europe-west1.firebasedatabase.app";
const DEV_DATABASE =
    "https://nodiant-e20a8-46dbf-dev.europe-west1.firebasedatabase.app";

// Which Realtime Database instance the website talks to.
//
// Set REACT_APP_USE_DEV_DATABASE=true in .env.development.local to point at
// dev. That file is gitignored AND react-scripts loads it for `start` but
// never for `build`, so a dev switch cannot reach a production deploy. This
// replaces commenting two config blocks in and out, which could be committed
// by accident and then shipped — `firebase deploy` reads the working tree.
//
// NOTE: only the DATABASE changes. Firebase Auth, Storage and the deployed
// cloud functions are per-project and stay LIVE either way.
const useDevDatabase = process.env.REACT_APP_USE_DEV_DATABASE === "true";

export const config = {
    apiKey: "AIzaSyA_GjxeB7UCwclsEiOx9OfN-K3T7gdc_0Y",
    authDomain: "nodiant-e20a8.firebaseapp.com",
    databaseURL: useDevDatabase ? DEV_DATABASE : LIVE_DATABASE,
    projectId: "nodiant-e20a8",
    storageBucket: "nodiant-e20a8.appspot.com",
    messagingSenderId: "412204354266",
    appId: "1:412204354266:web:1173dcab02e3dbf9c073e3",
    measurementId: "G-99JJLCDVV9",
};

// Initialize Firebase
firebase.initializeApp(config);
firebase.analytics();

if (useDevDatabase) {
    // Loud on purpose: the interface looks identical on either instance, and
    // the expensive mistake is doing real work while pointed at dev.
    console.warn(
        "%c DEV DATABASE ",
        "background:#8a5a00;color:#fff;font-weight:700",
        "Reading and writing " + DEV_DATABASE + ".\n" +
            "Auth, Storage and cloud functions are still LIVE — creating or " +
            "deleting a user, or sending any notification, affects real " +
            "accounts and real people.",
    );
}

// Route callable functions to a local emulator for safe testing against
// un-deployed function code:
//   terminal 1:  npm run functions:serve   (source: cloud-functions/)
//   terminal 2:  npm run start:emulated
if (process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true") {
    firebase.functions().useFunctionsEmulator("http://localhost:5001");
}

export default firebase;
